import { render, staticRenderFns } from "./schoolImg.vue?vue&type=template&id=73263024&scoped=true"
import script from "./schoolImg.vue?vue&type=script&lang=js"
export * from "./schoolImg.vue?vue&type=script&lang=js"
import style0 from "./schoolImg.vue?vue&type=style&index=0&id=73263024&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73263024",
  null
  
)

export default component.exports